import { getCookie as cookieParser } from './cookieParser';

interface CookieOptions {
  key: string;
  value: any;
  domain?: string;
  path?: string;
  maxAge?: number;
  expires?: Date;
  secure?: boolean;
}

function setCookie({ key, value, domain, path = '/', maxAge, expires, secure }: CookieOptions) {
  if (typeof window === 'undefined') return;

  if (maxAge && expires) {
    throw new Error('Cannot use both maxAge and expires in the same cookie');
  }

  let cookieString = `${key}=${encodeURIComponent(value)}; path=${path};`;
  if (domain) {
    cookieString += ` domain=${domain};`;
  }
  if (secure || window.location.protocol === 'https:') {
    cookieString += ' secure;';
  }
  if (maxAge) {
    cookieString += ` max-age=${maxAge};`;
  }
  if (expires) {
    cookieString += ` expires=${expires.toUTCString()};`;
  }

  document.cookie = cookieString;
}

function getCookie(key: string) {
  if (typeof window === 'undefined') return;

  return cookieParser(key);
}

export const clientSideCookies = { setCookie, getCookie };
